module.exports = __webpack_public_path__ + "static/media/cat-and-dog-cuddling.24ae2158.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat-and-dog-cuddling.jpg
// module id = 311
// module chunks = 0